import React, { useContext, useEffect, useState } from 'react';
import UserContext from '../../../common/utils/getContext';
import moment from 'moment';

const TimePass = ({ val }) => {
    const [date, setDate] = useState('');
    const { time, lang } = useContext(UserContext);
    useEffect(() => {
        if (!date) {
            setDate(
                moment
                    .duration(-((time().unix() - val) * 1000), 'milliseconds')
                    .locale(lang)
                    .humanize(true)
            );
        }
    }, [date, lang, time, val]);
    return <div>{date}</div>;
};
export default TimePass;
